import { render, staticRenderFns } from "./words.vue?vue&type=template&id=26d5d5d9&scoped=true"
import script from "./words.vue?vue&type=script&lang=js"
export * from "./words.vue?vue&type=script&lang=js"
import style0 from "./words.vue?vue&type=style&index=0&id=26d5d5d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d5d5d9",
  null
  
)

export default component.exports